<template>
    <div>
        <b v-if="displayStatus"
           class="label"
           :class="displayStatus | statusColor"
        >
            {{ displayStatusName }}
        </b>
        <span v-else>-</span>
    </div>
</template>

<script>
export default {
    name: 'StatusColumn',
    props: {
        row: {
            type: Object,
            required: true
        },
    },
    computed: {
        displayStatus() {
            return this.row.status
        },
        displayStatusName() {
            return this.row.status_name
        }
    }
}
</script>
